import React from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { listLanguage } from '../../../../../configs/LanguageConfig';
import {
  REDUCER_NAME,
  callApiSystemSetting,
  saveInfoCheckedPersonalSetting,
} from './../../../sidebar/reducer';
import { getUnique } from '../../../../helpers/Common';

const contactMethod = {
  both: 'Both',
  email: 'Email',
  mobilePhone: 'MobilePhone',
};

const EMAIL = 'email';
const MOBILE_PHONE = 'mobilephone';

const TIME_SHOW = 5000;

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.email,
      mobilephone: props.mobilephone,
      dataSystem: {},
      isShowSuccessMessage: false,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { isLoading } = this.props;
    if (isLoading && !nextProps.isLoading) {
      this.setState({
        isShowSuccessMessage: true,
      });

      this.timeout = setTimeout(() => {
        this.setState({
          isShowSuccessMessage: false,
        });
      }, TIME_SHOW);
    }
  }

  changeContactMethod = (key, checked) => () => {
    this.setState({ ...this.state, [key]: checked });
  };

  isDisableCheckbox = key => {
    const { email, mobilephone } = this.state;
    let disable = false;
    if (email && !mobilephone) {
      if (key === EMAIL) {
        disable = true;
      }
    }
    if (mobilephone && !email) {
      if (key === MOBILE_PHONE) {
        disable = true;
      }
    }
    return disable;
  };

  renderCheckbox = (key, checked) => {
    return (
      <div
        className="checkbox wrap-checkbox-first-column-body"
        style={{ marginLeft: -5 }}
        key={getUnique() + key}
        onClick={this.changeContactMethod(key, !checked)}
      >
        <input
          id={key}
          type="checkbox"
          checked={checked}
          readOnly
          disabled={this.isDisableCheckbox(key)}
        />
        <label>
          <Translate value={`systemSetting.userInfo.${key}`} />
        </label>
      </div>
    );
  };

  renderRowInfoUser = (title, value) => {
    const { email, mobilephone } = this.state;
    return (
      <div className="div-info-user">
        <span className="span-title-row">
          <Translate value={title} />
        </span>
        {value ? (
          <span>{value}</span>
        ) : (
          <>
            {this.renderCheckbox(EMAIL, email)}
            {this.renderCheckbox(MOBILE_PHONE, mobilephone)}
          </>
        )}
      </div>
    );
  };

  getCheckedCheckbox = () => {
    let valueChecked = '';
    const { email, mobilephone } = this.state;
    if (email && mobilephone) {
      return contactMethod.both;
    }
    if (email) {
      valueChecked = contactMethod.email;
    } else {
      valueChecked = contactMethod.mobilePhone;
    }
    return valueChecked;
  };

  saveContactMethod = () => {
    const { callApiSystemSetting, saveInfoCheckedPersonalSetting } = this.props;
    const { email, mobilephone } = this.state;
    saveInfoCheckedPersonalSetting({ email, mobilephone });
    callApiSystemSetting({
      contactMethod: this.getCheckedCheckbox(),
    });
  };

  renderButton = () => {
    const { isShowSuccessMessage } = this.state;
    return (
      <>
        <div className="button-user-info">
          <div className="save" onClick={this.saveContactMethod}>
            <Translate value={`systemSetting.userInfo.button.save`} />
          </div>
        </div>

        {isShowSuccessMessage && (
          <div className="save-message">
            <i className="icon-info" />
            <Translate value="layout.saveSettingMessage" />
          </div>
        )}

        <div className="line-dotted" />
      </>
    );
  };

  render() {
    const { userInfo, locale } = this.props;
    const link =
      locale === listLanguage.en
        ? 'https://web.fiintrade.vn/en/change-password/'
        : 'https://web.fiintrade.vn/doi-mat-khau/ ';

    return (
      <div className="body-user-info">
        <div className="row-myprofile">
          <Translate value={`systemSetting.userInfo.myProfile`} />
        </div>
        <div className="row-myprofile text-watter">
          <a href={link} rel="noreferrer noopener" target="_blank">
            <Translate value={`systemSetting.userInfo.changePassword`} />
          </a>
        </div>
        {this.renderRowInfoUser(
          `systemSetting.userInfo.emailAddress`,
          userInfo.profile.email,
        )}
        {this.renderRowInfoUser(`systemSetting.userInfo.mobileNumber`, `     `)}

        {this.renderRowInfoUser(
          `systemSetting.userInfo.preferenceContact`,
          null,
        )}
        {this.renderButton()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state[REDUCER_NAME].userInfo.userInfoSystem,
    dataSystem: state[REDUCER_NAME].settingSystem.dataSystem,
    email: state[REDUCER_NAME].userInfo.email,
    mobilephone: state[REDUCER_NAME].userInfo.mobilephone,
    locale: state.i18n.locale,
    isLoading: state[REDUCER_NAME].settingSystem.isLoading,
  };
};

const mapDispatchToProps = {
  callApiSystemSetting,
  saveInfoCheckedPersonalSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyProfile);
